import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountdownCounterComponent } from '../countdown-counter.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [CountdownCounterComponent],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports:[CountdownCounterComponent]
})
export class CountdownCounterModule { }
